import BaseModel from "lib/model";

export default BaseModel.extend({
    props: {
        __key: {
            type: "string",
        },
        // condition keys for custom inventory filter
        __condition_key: {
            type: "string",
        },
        __condition_value_key: {
            type: "string",
        },
        // Mix max keys are for fields with ranges dates
        __min_key: {
            type: "string",
        },
        __max_key: {
            type: "string",
        },
        __name: {
            type: "string",
            required: true,
        },
        __type: {
            type: "string",
            values: ["standard", "autocomplete", "date", "radio"],
            required: true,
        },
        __uri: {
            type: "string",
        },
        __uri_key: {
            type: "string",
        },
        __data: {
            type: "array",
        },
        __min_date: {
            type: "utcDate",
        },
        __max_date: {
            type: "utcDate",
        },
        // Range in days if user selects a min or max date but the other is blank
        __default_date_range: {
            type: "number",
        },
        __default_open: {
            type: "boolean",
        },
        __query: {
            type: "string",
        },
        // check if the filter needs to be converted to id
        __convert_to_id: {
            type: "boolean",
        },
    },
});
